export default __webpack_public_path__ + "static/GESSTwoDWTC-Medium-8146a5664d46a0896fb5abfdfce1f66c.ttf";